import { useState } from 'react';
import { Link } from 'react-router-dom';
import { usePayRuns, useCreatePayRun } from '../../hooks/usePayRuns.js';
import { useError } from '../../components/shared/ErrorBanner.jsx';
import { centsToUsd, iso, toDateInput, weekRangeOffset } from '../../lib/format.js';

export default function PayRunsPage() {
  const { data: runs = [] } = usePayRuns();
  const [creating, setCreating] = useState(false);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
        <span style={{
          fontFamily: 'var(--font-label)', fontSize: 11, color: 'var(--warm-gray)',
          textTransform: 'uppercase', letterSpacing: '0.08rem',
        }}>
          {runs.length} run{runs.length === 1 ? '' : 's'}
        </span>
        <button className="btn-sm primary" onClick={() => setCreating(true)}>+ New pay run</button>
      </div>

      {creating && (
        <PayRunCreateForm
          onCancel={() => setCreating(false)}
          onDone={() => setCreating(false)}
        />
      )}

      <table className="tbl">
        <thead>
          <tr>
            <th>Period</th><th>Pay date</th><th>Status</th>
            <th>Provider</th><th className="num">Items</th>
            <th className="num">Gross</th><th></th>
          </tr>
        </thead>
        <tbody>
          {runs.map(r => (
            <tr key={r.id}>
              <td>{iso(r.period_start)} → {iso(r.period_end - 1)}</td>
              <td>{r.pay_date ? iso(r.pay_date) : '—'}</td>
              <td><span className={'badge' + (r.status === 'paid' ? ' orange' : '')}>{r.status}</span></td>
              <td><span className="badge">{r.provider}</span></td>
              <td className="num">{r.item_count}</td>
              <td className="num">{centsToUsd(r.gross_total_cents)}</td>
              <td><Link to={r.id} className="btn-sm">Open</Link></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function PayRunCreateForm({ onCancel, onDone }) {
  const def = weekRangeOffset(-1);
  const [from, setFrom]   = useState(toDateInput(def.from));
  const [to, setTo]       = useState(toDateInput(def.to - 1));
  const [payDate, setPayDate] = useState(toDateInput(def.to + 5 * 86400000));
  const [provider, setProvider] = useState('manual');
  const create = useCreatePayRun();
  const { show } = useError();

  const submit = async (e) => {
    e.preventDefault();
    try {
      await create.mutateAsync({
        period_start: Date.parse(from + 'T00:00:00Z'),
        period_end:   Date.parse(to + 'T00:00:00Z') + 86400000,
        pay_date:     payDate ? Date.parse(payDate + 'T00:00:00Z') : null,
        provider,
      });
      onDone();
    } catch (err) { show(err.message); }
  };

  return (
    <form onSubmit={submit} style={{ padding: 16, background: 'var(--surface-container)', marginBottom: 16 }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8 }}>
        <div className="field"><label className="field-label">Period start</label>
          <input className="field-input" type="date" value={from} onChange={e => setFrom(e.target.value)} required /></div>
        <div className="field"><label className="field-label">Period end (incl.)</label>
          <input className="field-input" type="date" value={to} onChange={e => setTo(e.target.value)} required /></div>
        <div className="field"><label className="field-label">Pay date</label>
          <input className="field-input" type="date" value={payDate} onChange={e => setPayDate(e.target.value)} /></div>
      </div>
      <div className="field">
        <label className="field-label">Provider</label>
        <select className="field-select" value={provider} onChange={e => setProvider(e.target.value)}>
          <option value="manual">Manual (CSV export)</option>
          <option value="nacha">NACHA file (ACH batch upload)</option>
          <option value="check">Check (not yet configured)</option>
        </select>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button className="btn-sm primary" type="submit" disabled={create.isPending}>
          {create.isPending ? 'Creating…' : 'Create draft'}
        </button>
        <button className="btn-sm" type="button" onClick={onCancel}>Cancel</button>
      </div>
    </form>
  );
}
